import React from 'react';
import { BarChart3 } from 'lucide-react';

function AnalyticsPanel({ analytics, loading }) {
  return (
    <div className="analytics-details">
      <h2><BarChart3 size={16} /> Analytics</h2>
      {loading ? (
        <div className="empty-state">Loading analytics...</div>
      ) : (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">{analytics.totalConversations}</div>
            <div className="stat-label">Total Conversations</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{analytics.todayConversations}</div>
            <div className="stat-label">Today</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{analytics.avgMessagesPerConversation.toFixed(1)}</div>
            <div className="stat-label">Avg. Messages/Conversation</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AnalyticsPanel; 